import { render, staticRenderFns } from "./GestioneAdmin.vue?vue&type=template&id=3c7f7a32&"
import script from "./GestioneAdmin.vue?vue&type=script&lang=js&"
export * from "./GestioneAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/pages/GestioneAdmin.vue
// module id = 918
// module chunks = 0